<script lang="ts">
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {getFormatter} from "../../utils";

    const formatter = getFormatter();
    export let total = 0;
</script>
<div class="pago-bar hidden m:block">
    <section class="py-1">
        <div class="container">
            <div class="box-b">
                <p style="font-weight: 600">Total a pagar {formatter(total)}</p>
                <NauiButton caption="Continuar pago" mode="solid" size="small" color="accent" on:click/>
            </div>
        </div>
    </section>
</div>
<style>
    .pago-bar {
        background: white;
        width: 100%;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.05);
    }
</style>